

// App.js
import { BrowserRouter } from 'react-router-dom';
import { MessageProvider, useMessage } from './contexts/MessageContext';
import Router from './routes/Router';
import Alarm from './components/alarm/alarm';
import { useEffect } from 'react';
import { messagingPromise, getToken, deleteToken, onMessage } from "./services/firebase";



function AppWrapper() {
  return (
    <MessageProvider>
      <App />
    </MessageProvider>
  );
}

function App() {
  const { setMessage } = useMessage();

  useEffect(() => {
  if (!window.location.hostname.startsWith('safemap-dev-admin.')) return;

  window.resetDevFcmToken = async () => {
    const messaging = await messagingPromise;

    if (!messaging) {
      console.error('[DEV FCM] Messaging 사용 불가');
      return;
    }

    try {
      const result = await deleteToken(messaging);
      console.log('[DEV FCM] 기존 토큰 삭제 결과:', result);
    } catch (err) {
      console.error('[DEV FCM] 기존 토큰 삭제 실패:', err);
    }
  };

  return () => {
    delete window.resetDevFcmToken;
  };
}, []);

  useEffect(() => {
    let unsubscribe = null;
    let cancelled = false;

    messagingPromise.then(async (messaging) => {
      if (!messaging || cancelled) {
        console.log("[CLONE] FCM 미지원 환경: 브라우저 푸시 초기화 보류");
        return;
      }

      try {
        const currentToken = await getToken(messaging, {
		vapidKey: "BJ-eFo62LRTTcPZiDzYTlbUj0_DrXqzrkuYLp10Xm5dDTiDzQb4ALOgpQS_PAwrsZbWP-RKy7d7vwT6qOjaz0TQ"
        });

        if (currentToken) {
          console.log("FCM 토큰 발급 성공");
        }
      } catch (err) {
        console.error("FCM 토큰 발급 에러:", err);
      }

      if (cancelled) return;

      unsubscribe = onMessage(messaging, (payload) => {
        console.log("웹에서 FCM 수신:", payload);

        setMessage({
          title: payload.notification?.title || "제목 없음",
          body: payload.notification?.body || "내용 없음",
          data: payload.data || {},
        });
      });
    }).catch((err) => {
      console.error("FCM 초기화 오류:", err);
    });

    return () => {
      cancelled = true;
      if (unsubscribe) unsubscribe();
    };
  }, [setMessage]);

  return (
    <>
      <BrowserRouter>
        <Router />
      </BrowserRouter>
      <Alarm />
    </>
  );
}

export default AppWrapper;
